import { createSvgComponent } from "../../icon/createSvgComponent";
import Trash from "@core/__generated__/icon/figma/trash.svg";
export default createSvgComponent(Trash);